<div mat-dialog-title>Edit an existing Blended Model
    <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>
<mat-dialog-content>
    <div id="edit-existing-blended-dialog">
        <div style="margin: 8px 0 12px 0;">Select a blended model to edit.</div>

        <div style="display: flex;margin-bottom:20px;" id="edit-existing-blended-dialog-select-model">
            <label>Model Name:</label>
            <irb-dropdown-filter #IrbDropdownBlendedModels (search)="getModels($event)" placeholder="Select a Model"
                                 [disabled]="disabledDropDown"
                                 size="50" hoverPanelWidth="395"
                                 [(value)]="selectedModel"
                                 (selection)="onSelectModel($event)"></irb-dropdown-filter>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="openBlended()" class="btn-medium-primary" [disabled]="canNotContinue">Continue</button>
</mat-dialog-actions>
